import React, { useState } from 'react'
import { useQuery } from '@apollo/client'
import { get } from 'lodash'
import LinearProgress from '@material-ui/core/LinearProgress'
import RateReviewOutlinedIcon from 'components/material-symbol/icons/RateReview'
import { CoachReviewsQuery } from './query'
import CoachReviews from 'components/coach-reviews'
import AskForReviewsModal from 'components/coach-reviews-request'
import SectionEmptyState from 'components/section-empty-state'
import { TonalButton } from 'components/empty-page-state'
import Error from 'components/error'
import Box from '@material-ui/core/Box'
import { useStyles } from './styles'

const CoachReviewsView = () => {
  const classes = useStyles()
  const { data, loading, error, refetch } = useQuery(CoachReviewsQuery)
  const [open, setOpen] = useState(false)

  if (loading) return <LinearProgress color="primary" />
  if (error) return <Error />

  const coachReviews = get(data, 'GetCoachReviews.coachReviews', []) || []
  const coachProfile = get(coachReviews, '[0].coachProfile', {}) || {}

  const completedReviews = coachReviews
    .filter(review => review)
    .filter(({ status }) => status === 'COMPLETE')

  return (
    <>
      <Box className={classes.coachProfileCardsContainer}>
        {completedReviews.length ? (
          <CoachReviews
            coachProfile={coachProfile}
            coachReviews={data.GetCoachReviews}
            open={open}
            setOpen={setOpen}
          />
        ) : (
          <Box className={classes.emptyStateContent}>
            <SectionEmptyState
              Icon={RateReviewOutlinedIcon}
              title="Reviews"
              caption="Feedback from your students will appear here."
              bordered={false}
              action={
                <TonalButton onClick={() => setOpen(true)}>
                  Ask for Reviews
                </TonalButton>
              }
            />
          </Box>
        )}
      </Box>
      <AskForReviewsModal {...{ coachReviews, refetch, open, setOpen }} />
    </>
  )
}

export default CoachReviewsView
